import { machGetUrlParameterByName } from "./main";
import { Fancybox } from "@fancyapps/ui";

jQuery(document).ready(function () {
    machInitOnLoadContentPopups();
    machInitOnLoadSimplePopups();

    jQuery(".newsletter-btn").on("click", machOpenNewsletterPopup);
    jQuery(document).on("click", ".promotion-popup-link", machOpenPromotionPopup);
    jQuery(document).on("click", ".service-popup-link", machOpenServicePopup);
    jQuery(document).on("click", ".job-email-popup-link", machOpenJobEmailPopup);
    jQuery(document).on("click", "[data-content-popup-link]", machOpenSimpleContentPopup);
    jQuery(".header-search .search-btn").on("mousedown", machOpenSearchPopup);

    // Initialize Fancybox for each links leading to images
    Fancybox.bind('a[href*=".jpg"],a[href*=".jpeg"],a[href*=".svg"],a[href*=".webp"],a[href*=".png"],a[href*=".gif"]', {});
    Fancybox.bind("[data-fancybox='video']", {
        iframe: {
            preload: false, // Prevents auto-loading the video
            css: {
                width: "80%", // Adjust iframe width
                height: "80%", // Adjust iframe height
            },
        },
    });
});

function machOpenNewsletterPopup(e) {
    e.preventDefault();
    Fancybox.show(
        [
            {
                src: "#newsletter-popup",
                type: "inline",
            },
        ],
        {
            hideScrollbar: false,
            autoFocus: false,
        }
    );
}

function machOpenPromotionPopup(e) {
    e.preventDefault();
    let promo_id = jQuery(this).data("promo-id");
    Fancybox.show(
        [
            {
                src: "#promotion-popup-" + promo_id,
                type: "inline",
            },
        ],
        {
            hideScrollbar: false,
            autoFocus: false,
            dragToClose: false,
        }
    );
}

function machOpenServicePopup(e) {
    e.preventDefault();
    let service_id = jQuery(this).data("service-id");
    Fancybox.show(
        [
            {
                src: "#service-popup-" + service_id,
                type: "inline",
            },
        ],
        {
            hideScrollbar: false,
            autoFocus: false,
            dragToClose: false,
        }
    );
}

function machOpenJobEmailPopup(e) {
    e.preventDefault();
    let job_id = jQuery(this).data("job-id");
    Fancybox.show(
        [
            {
                src: "#job-email-popup-" + job_id,
                type: "inline",
            },
        ],
        {
            hideScrollbar: false,
            autoFocus: false,
            dragToClose: false,
        }
    );
}

function machOpenSimpleContentPopup(e) {
    e.preventDefault();
    let content = jQuery(this).data("content-popup-link");
    Fancybox.show(
        [
            {
                src: content,
                type: "html",
            },
        ],
        {
            hideScrollbar: false,
            autoFocus: false,
            dragToClose: false,
        }
    );
}

function machOpenSearchPopup(e) {
    e.preventDefault();

    Fancybox.show(
        [
            {
                src: "#search-popup",
                type: "inline",
            },
        ],
        {
            hideScrollbar: false, // Désactive le scroll sur la page
            autoFocus: false,
            on: {
                done: () => {
                    setTimeout(() => {
                        document.querySelector('#search-popup input[type="search"]').focus();
                    }, 100);
                },
                close: () => {
                    // Facultatif : réinitialise le scroll si besoin
                    document.body.style.overflow = "";
                },
            },
        }
    );
}

function machInitOnLoadContentPopups() {
    let popupParam = machGetUrlParameterByName("popup");
    if (popupParam) {
        Fancybox.show(
            [
                {
                    src: backendInfo.ajaxurl,
                    type: "ajax",
                    ajax: new URLSearchParams({
                        action: "mach_retrieve_specific_popup_content",
                        popup_data: popupParam,
                    }).toString(),
                },
            ],
            {
                hideScrollbar: false,
                autoFocus: false,
                dragToClose: false,
            }
        );
    }
}

function machInitOnLoadSimplePopups(e) {
    let $popup = jQuery("#onload-simple-popup");
    if ($popup.length > 0) {
        let delay = $popup.data("delay") || 0;
        setTimeout(() => {
            Fancybox.show(
                [
                    {
                        src: "#onload-simple-popup",
                        type: "inline",
                    },
                ],
                {
                    hideScrollbar: false,
                    autoFocus: false,
                    dragToClose: false,
                }
            );
        }, delay);
    }
}
